import moment from 'moment'

export default function toMoment (date, format, clone = false) {
  if (typeof format !== 'string' && arguments.length === 2) {
    clone = !!format
    format = undefined
  }
  if (date) {
    if (!moment.isMoment(date)) {
      date = moment(date, format)
    }
    if (clone) {
      date = date.clone()
    }
    return date.isValid() ? date : null
  }
  return null
}
